import React from "react";
import { ApproveInnovationAnnouce10Container } from "../../../containers/SupportSystem/SupportForm/ApproveInnovationAnnouce10Container";

export function ApproveInnovationAnnouce10Page () {
    return(
        <ApproveInnovationAnnouce10Container/>
    )
}